export default __webpack_public_path__ + "static/media/maps.75ba2eb6.svg";